import { render, staticRenderFns } from "./requestTranslation.vue?vue&type=template&id=fec84dc0&"
import script from "./requestTranslation.vue?vue&type=script&lang=js&"
export * from "./requestTranslation.vue?vue&type=script&lang=js&"
import style0 from "./requestTranslation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports